export default defineNuxtPlugin(() => {
  useHead({
    script: [
      {
        src: '/likec4-assets/likec4-webcomponent.js',
        defer: true,
        type: 'module',
        tagPosition: 'bodyClose',
      },
    ],
  })
})
